import { render, staticRenderFns } from "./OrdersFiltersModal.vue?vue&type=template&id=1a169a9f&"
import script from "./OrdersFiltersModal.vue?vue&type=script&lang=js&"
export * from "./OrdersFiltersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports